<template>
    <div id="configuration">
        <template v-if="isLoaded">
            <template v-if="systemConf.length > 0">
                <form>
                    <div class="form-group row" v-for="conf in systemConf" :key="conf.key">
                        <label class="col-3 col-form-label">{{ $t("manager.configuration." + conf.key) }}</label>
                        <div class="col-9">
                            <input type="text" readonly class="form-control-plaintext" v-model="conf.value">
                        </div>
                    </div>
                </form>
            </template>
            <template v-else>
                <div class="alert alert-warning">
                    {{ $t("noRows") }}
                </div>
            </template>
        </template>
        <template v-else>
            <div class="text-center">
                <font-awesome-icon icon="spinner" pulse />
            </div>
        </template>
    </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      isLoaded: false,
      systemConf: []
    }
  },
  methods: {
    loadConfiguration () {
      let me = this
      axios.get(me.$store.getters.urlPath + 'services/manager/getConfiguration.php')
        .then(function (response) {
          me.systemConf.push({ key: 'path', value: response.data.path })
          me.systemConf.push({ key: 'dbHost', value: response.data.dbHost })
          me.systemConf.push({ key: 'dbPrefix', value: response.data.dbPrefix })
          me.systemConf.push({ key: 'privateIn', value: response.data.privateIn })
          me.systemConf.push({ key: 'privateBackups', value: response.data.privateBackups })
          me.systemConf.push({ key: 'baseUrl', value: response.data.baseUrl })
          me.systemConf.push({ key: 'billingEmail', value: response.data.billingEmail })
          me.isLoaded = true
        })
        .catch(function (error) {
          // eslint-disable-next-line
          console.log(error)
        })
    }
  },
  created () {
    this.loadConfiguration()
  }
}
</script>
